// src/services/monitoringSocket.js
// Socket.IO client for the backend "/monitoring" namespace (live dashboard).
import { io } from 'socket.io-client';

// Backend origin without the trailing /api (sockets connect to the host root).
function socketBaseUrl() {
  const base = process.env.REACT_APP_API_BASE_URL;
  if (base) return base.replace(/\/$/, '');
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
  return apiUrl.replace(/\/api\/?$/, '');
}

let socket = null;

export function getMonitoringSocket() {
  const token = localStorage.getItem('token');
  if (!socket) {
    socket = io(`${socketBaseUrl()}/monitoring`, {
      auth: { token },
      query: { token },
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 2000,
    });
  }
  return socket;
}

export function disconnectMonitoringSocket() {
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }
}
